// extracted by mini-css-extract-plugin
export default {"textHeader":"payment-method-transaction-modal_textHeader__URZTh","header":"payment-method-transaction-modal_header__dCKdZ"};